import { render, staticRenderFns } from "./add_organ.vue?vue&type=template&id=5c428662&scoped=true&"
import script from "./add_organ.vue?vue&type=script&lang=js&"
export * from "./add_organ.vue?vue&type=script&lang=js&"
import style0 from "./add_organ.vue?vue&type=style&index=0&id=5c428662&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c428662",
  null
  
)

export default component.exports